import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Auth } from 'aws-amplify';
import Link from 'next/link';
import Image from 'next/image';
import { setLocalSession } from '@/utils/auth';
import { LoginFormWrapper, Warning } from '@/styles/auth.styles';
import { signIn, useSession } from 'next-auth/client';
import CodeConfirmationForm from './CodeConfirmation';

const SignupForm = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [session, sessionLoading] = useSession();

  useEffect(() => {
    const sessionLogin = async () => {
      // have session
      // console.log('useeffect signin');
      // console.log({ session });
      await setLocalSession(session);
      // redirect??
      if (router) {
        router.replace('/dashboard');
      }
    };
    if (!sessionLoading && session) {
      sessionLogin();
    }
  }, [session, sessionLoading, router]);

  const onSubmit = async e => {
    e.preventDefault();
    // console.log('submitting');
    await setLoading(true);
    await setError('');
    if (password !== passwordConfirm) {
      await setLoading(false);
      return setError('*Passwords must be equal');
    }
    if (!email || !password) {
      await setLoading(false);
      return setError('*Please, fill the required fields');
    }

    try {
      await Auth.signUp({
        username: email,
        password,
        attributes: {
          email
          // phone: '' // phone?
        }
      });
      // await sendWelcomeEmail({ email });
      await setLoading(false);
      await setConfirmation(true);
    } catch (err) {
      // console.log(err.message);
      // console.log({ err: err.message });
      let errMessage = err.message;
      await setError(err.message);
      if (
        err.message ===
        `1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6`
      ) {
        errMessage = `Password must have length greater than or equal to 6 characters`;
      }
      if (err.message === `User already exists`) {
        errMessage = `User already exists`;
      }

      await setError(errMessage);
      await setLoading(false);
    }
  };

  return (
    <LoginFormWrapper>
      <div className="app-login">
        {!confirmation && (
          <>
            <div className="social-login-buttons">
              <button type="button" onClick={() => signIn('google')}>
                <div className="social-icon">
                  <Image src="/imgs/social/google.png" alt="google social" width={24} height={24} />
                </div>{' '}
                <div className="social-text">Sign up with Google</div>
              </button>
            </div>
            <div className="auth-separator">or</div>
          </>
        )}
        {confirmation ? (
          <CodeConfirmationForm email={email} password={password} />
        ) : (
          <form onSubmit={onSubmit}>
            <div className="field-wrapper">
              <div className="label">Email</div>
              <input
                type="text"
                name="email"
                placeholder="Enter your email"
                autoComplete="username"
                className="app-input"
                aria-label="Enter your email"
                onChange={e => setEmail(e.target.value)}
                disabled={loading}
                value={email}
              />
            </div>

            <div className="field-wrapper">
              <div className="label">Password</div>
              <input
                type="password"
                name="password"
                placeholder="Enter your password"
                autoComplete="new-password"
                className="app-input"
                aria-label="Enter your password"
                onChange={e => setPassword(e.target.value)}
                disabled={loading}
                value={password}
              />
            </div>

            <div className="field-wrapper">
              <div className="label">Password confirm</div>
              <input
                type="password"
                name="passwordConfirm"
                // passwordShowHide
                placeholder="Confirm your password"
                autoComplete="new-password"
                className="app-input"
                aria-label="Confirm your password"
                onChange={e => setPasswordConfirm(e.target.value)}
                disabled={loading}
                value={passwordConfirm}
              />
            </div>

            <div className="field-wrapper submit">
              <button type="submit" disabled={loading}>
                {loading ? 'Signing up...' : 'Sign Up'}
              </button>
            </div>
            {error && (
              <div className="field-wrapper error">
                <Warning>{error}</Warning>
              </div>
            )}
          </form>
        )}
        {/* <br /> */}
        <div className="login-form-switch">
          Already have an account?{' '}
          <Link href="/login">
            <a>Sign In</a>
          </Link>
        </div>
      </div>
    </LoginFormWrapper>
  );
};

export default SignupForm;
